// 配置 WebSocket 連接
function configureWebSocket() {
  if (typeof window === 'undefined') return;
  
  try {
    // 獲取當前頁面的主機和端口
    const host = window.location.hostname;
    const port = window.location.port || (window.location.protocol === 'https:' ? '443' : '80');
    
    // 設置全局變數供 Vite 客戶端使用
    window.__vite_ws_host = host;
    window.__vite_ws_port = port;
    
    // 覆蓋 Vite 的 WebSocket 連接函數
    const originalWebSocket = window.WebSocket;
    window.WebSocket = function(url, protocols) {
      // 如果是 Vite HMR WebSocket 連接
      if (url.includes('localhost:8080') && url.includes('vite-hmr')) {
        // 替換為當前頁面的主機和端口
        url = url.replace('localhost:8080', `${host}:${port}`);
        console.log('修正 WebSocket 連接:', url);
      }
      return new originalWebSocket(url, protocols);
    };
    
    console.log(`WebSocket 配置：連接到 ${host}:${port}`);
  } catch (error) {
    console.error('WebSocket 配置錯誤:', error);
  }
}

// 在頁面加載時執行
if (typeof window !== 'undefined') {
  // 立即執行一次
  configureWebSocket();
  
  // 在頁面完全加載後再執行一次
  window.addEventListener('load', configureWebSocket);
}

export default configureWebSocket; 